import { type FC } from 'react';

import { THeadCellText, type THeadCellTextProps } from '../thead-cell-text';
import { Flex, Tooltip } from 'antd';
import { ConditionalWrapper } from '@shared/ui/conditional-wrapper';
import { Text, type TypographyVariant } from '@shared/ui/antd';

const MAX_TEXT_LENGTH = 80;

export type THeadCellTooltipExpandProps = THeadCellTextProps & {
  text?: string | null;
  variant?: TypographyVariant;
  fontWeight?: React.CSSProperties['fontWeight'];
  maxLength?: number;
};

export const THeadCellTooltipExpand: FC<THeadCellTooltipExpandProps> = ({
  children,
  width,
  text,
  variant = 'md',
  fontWeight = 400,
  maxLength = MAX_TEXT_LENGTH,
  ...props
}) => {
  const hasLongText = text && text?.length > maxLength;
  const textSlice = hasLongText ? `${text.slice(0, maxLength)}...` : text;

  return (
    <THeadCellText {...props} onClick={() => {}} width={width}>
      <ConditionalWrapper
        condition={hasLongText || false}
        wrapper={(children) => (
          <Tooltip
            title={text}
            placement="topLeft"
            style={{ textAlign: 'left', maxWidth: '600px' }}
          >
            {children}
          </Tooltip>
        )}
      >
        <Flex
          align="center"
          style={{
            columnGap: '4px',
            width,
          }}
        >
          <Text variant={variant} fontWeight={fontWeight}>
            {textSlice}
          </Text>
        </Flex>
      </ConditionalWrapper>
    </THeadCellText>
  );
};
